import { useReveal } from "../lib/useReveal";

/**
 * Wrap any section to give it a cinematic scroll-reveal entrance.
 * Uses the existing `.reveal` + `.in` CSS in index.css (respects prefers-reduced-motion).
 *
 *   <RevealOnScroll>
 *     <Services />
 *   </RevealOnScroll>
 *
 * `as="section"` lets you preserve semantic anchors when needed.
 */
export default function RevealOnScroll({ children, className = "", as: As = "div", delay }) {
  const { ref, visible } = useReveal();
  const style = delay !== undefined ? { transitionDelay: `${delay}ms` } : undefined;
  return (
    <As ref={ref} className={`reveal ${visible ? "in" : ""} ${className}`} style={style}>
      {children}
    </As>
  );
}
